import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const BinIcon: FC<IconProps> = ({ size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M12.6548 4.96387H3.34447C3.21538 4.96387 3.12894 5.08188 3.14354 5.19989L4.192 13.8947C4.26384 14.5285 4.79536 15 5.41332 15H10.586C11.204 15 11.7209 14.5285 11.8073 13.8947L12.8704 5.19989C12.885 5.06749 12.7845 4.96387 12.6548 4.96387H12.6548Z'
          fill={color} />
    <path fillRule='evenodd' clipRule='evenodd'
          d='M13.3014 2.25264H9.63746V1.41275C9.63746 1.17673 9.45056 1 9.23503 1H6.79238C6.56225 1 6.38994 1.1917 6.38994 1.41275L6.3905 2.25264H2.69794C2.46781 2.25264 2.2955 2.44434 2.2955 2.66539V3.50528C2.2955 3.74131 2.48241 3.91804 2.69794 3.91804H13.3021C13.5322 3.91804 13.7045 3.72634 13.7045 3.50528V2.66539C13.7039 2.44434 13.5316 2.25264 13.3015 2.25264H13.3014Z'
          fill={color} />
  </svg>
)

export default BinIcon
